import React from 'react'
import { LuTriangleAlert } from 'react-icons/lu'

import { Alert, AlertDescription } from '@/components/ui/alert'

const DataDisclaimer: React.FC = () => (
  <Alert variant="warning" className="relative top-0.75 mt-4 mb-0">
    <LuTriangleAlert />

    <AlertDescription>
      RQ has generated this profile based on public data. This firm is not a
      member of RQ and these details are unconfirmed.
    </AlertDescription>
  </Alert>
)

export default DataDisclaimer
